<div class="option-code-wrapper">
  <lib-question-answer-option-code
    class="option-code"
    [index]="index"
    [numeric]="numeric">
  </lib-question-answer-option-code>

  @if (visited) {
    <div class="visited-icon">
      <lib-icon icon="check-circle" [fill]="true" [size]="mediaType === mediaTypes.IMAGE ? 32 : 20"></lib-icon>
    </div>
  }
</div>

@switch (mediaType) {
  @case (mediaTypes.IMAGE) {
    <div class="option-media-container"
      [dynamicWidthCoeff]="3"
      [cardBackground]="{ backgroundColor: null, mediaBackground: mediaImage }">
      <div class="media-ratio-aspect" [ngClass]="mediaRatio" ></div>
    </div>
  }
  @default {
    <span class="option-text" [innerHTML]="text | safeHtml"></span>
  }
}

@if (canEdit) {
  <div class="card-actions">
    @if (!isTranslation) {
      <button
        mat-icon-button
        cdkDragHandle
        class="drag-handle button button--icon button--icon-extra-small button--black">
        <lib-icon icon="equals"></lib-icon>
      </button>
    }
    <button
      mat-icon-button
      class="button button--icon button--icon-extra-small button--black"
      (click)="edit.emit()">
      <lib-icon icon="pencil-simple"></lib-icon>
    </button>
    @if (!isTranslation) {
      <button
        mat-icon-button
        class="button button--icon button--icon-extra-small button--black"
        (click)="remove.emit()">
        <lib-icon icon="trash"></lib-icon>
      </button>
    }
  </div>
}
